export interface MappedDiscountResponse {
    id: string;
    name: string;
    rewardType: RewardType;
    rewardAmount: number | null;
    rules: DiscountRule[];
    requiresMinSpend: boolean;
    minSpend: number | null;
    hasMaxDiscountAmount: boolean;
    maxDiscountAmount: number | null;
    hasSchedule: boolean;
    startDate: string | null;
    endDate: string | null;
    version: string;
    deleted: boolean;
}

export const REWARD_TYPE = {
    PERCENTAGE: 'PERCENTAGE',
    AMOUNT: 'AMOUNT',
    MANUAL_PERCENTAGE: 'MANUAL_PERCENTAGE',
    MANUAL_AMOUNT: 'MANUAL_AMOUNT',
} as const;

export type RewardType = (typeof REWARD_TYPE)[keyof typeof REWARD_TYPE];

export interface DiscountRule {
    ruleType: DiscountRuleType;
    includings: string[];
}

export const DISCOUNT_RULE_TYPE = {
    CUSTOMER_GROUP: 'CUSTOMER_GROUP',
} as const;

export type DiscountRuleType =
    (typeof DISCOUNT_RULE_TYPE)[keyof typeof DISCOUNT_RULE_TYPE];

export const PERCENTAGE_BASED_DISCOUNTS: RewardType[] = [
    REWARD_TYPE.PERCENTAGE,
    REWARD_TYPE.MANUAL_PERCENTAGE,
];

export const AMOUNT_BASED_DISCOUNTS: RewardType[] = [
    REWARD_TYPE.AMOUNT,
    REWARD_TYPE.MANUAL_AMOUNT,
];

export const MANUAL_DISCOUNTS: RewardType[] = [
    REWARD_TYPE.MANUAL_PERCENTAGE,
    REWARD_TYPE.MANUAL_AMOUNT,
];

export const DISCOUNT_TYPE_DISPLAY_ORDER: Record<RewardType, number> = {
    [REWARD_TYPE.PERCENTAGE]: 0,
    [REWARD_TYPE.MANUAL_PERCENTAGE]: 1,
    [REWARD_TYPE.AMOUNT]: 2,
    [REWARD_TYPE.MANUAL_AMOUNT]: 3,
};
